import { checkNested, getNested } from './validator'
import history from 'srcReact/helpers/history'
import { getCookie, isNative, urlSearchParams } from './utils'

export const hasNotifications = (orgas, current_organization) => {
  const restOrgs = orgas.filter((o) => o.id !== current_organization.info.id)
  return restOrgs.some((e) => e.notificationsNumber > 0)
}

export const getCurrentOrg = () => {
  if (isNative()) {
    let currentOrganization = JSON.parse(urlSearchParams('current_organization'))
    if (checkNested(currentOrganization, 'info')) {
      return currentOrganization
    } else {
      return null
    }
  }
  if (localStorage.getItem('current_organization') != null) {
    const org = JSON.parse(localStorage.getItem('current_organization'))
    return org ? org : null
  } else {
    return null
  }
}

export const getCurrentOrgId = () => {
  if (isNative()) {
    let currentOrganization = JSON.parse(urlSearchParams('current_organization'))
    if (checkNested(currentOrganization, 'info', 'id')) {
      return currentOrganization.info.id
    } else if (urlSearchParams('current_organization_id')) {
      return urlSearchParams('current_organization_id')
    } else if (urlSearchParams('organization_id')) {
      return urlSearchParams('organization_id')
    } else {
      return null
    }
  }
  if (localStorage.getItem('current_organization') != null) {
    const org = JSON.parse(localStorage.getItem('current_organization'))
    return org ? org.id : null
  } else if (getCookie('current_organization_id')) {
    return getCookie('current_organization_id')
  } else {
    return null
  }
}

export const getCurrentApiDomain = () => {
  if (isNative()) {
    let currentOrganization = JSON.parse(urlSearchParams('current_organization'))
    if (checkNested(currentOrganization, 'info', 'apiSubdomain')) {
      return currentOrganization.info.apiSubdomain
    }
    return ''
  }
  if (localStorage.getItem('current_organization') != null) {
    let currentOrg = JSON.parse(localStorage.getItem('current_organization'))
    if (currentOrg) {
      return currentOrg.apiSubdomain
    }
  }
  return ''
}

const excludedRedirectionURL = ['your-invites', 'pricing-non-profit']
export const getRedirectUrlForWithoutPlan = (current_organization) => {
  let redirectPage = '/0/error-user'
  if (getNested(current_organization, 'info', 'roles') && current_organization.info.roles.includes('account_owner')) {
    const urls = excludedRedirectionURL.filter((URL) => history.location.pathname.includes(URL))
    if (urls.length === 0) {
      redirectPage = '/0/pricing'
    } else {
      redirectPage = ''
    }
  }
  return redirectPage
}

export const isOrganizationManager = (current_organization) => {
  let currentOrganization = current_organization
  if (isNative()) {
    currentOrganization = urlSearchParams('current_organization')
  }
  if (
    (getNested(currentOrganization, 'info', 'roles') && currentOrganization.info.roles.includes('account_owner')) ||
    getNested(currentOrganization, 'roles')
  ) {
    return true
  }
  return false
}
